export default "__VITE_PUBLIC_ASSET__20ffe1a5__"